import { Injectable } from '@angular/core';
import { AxiosService } from '../axios.service';
import { CustomHttpHeader, GetAuthorizeNetClientTokenResponse, GetBraintreeTokenResponse, GetEGHLHashResponse, GetHeartlandHashResponse, GetMonerisTicketResponse, GetPaymentConfigurationsResponse, GetStripeLinkResponse, GetXenditInvoiceResponse, UserBalanceResponse } from '@app/shared/models/userBalance';
import { GET_BALANCE, GET_BRAINTREE_TOKEN, GET_HEARTLAND_HASH, GET_MONERIS_TICKET, GET_PAYMENT_CONFIGURATION, GET_STRIPE_REDIRECT_URL, GET_XENDIT_INVOICE_URL, GET_AUTHORIZE_NET_TOKEN, OPERATION, GET_EGHL_HASH } from '@app/core/constants/query-constant';
import { ApiService } from '@app/core/http/api.service';
import { API_END_POINT } from '@app/core/constants/app-constant';

@Injectable({
  providedIn: 'root'
})
export class ApiAccountService {

  constructor(
    private axiosService: AxiosService,
    private apiService: ApiService
  ) { }

  getBalance(showLoader?): Promise<UserBalanceResponse> {
    return this.axiosService.post(GET_BALANCE, OPERATION.UserBalance, undefined, showLoader);
  }

  getPaymentConfiguration(variable): Promise<GetPaymentConfigurationsResponse>{
    return this.axiosService.post(GET_PAYMENT_CONFIGURATION, OPERATION.GetPaymentConfigurations, variable);
  }

  getStripeRedirectUrl(variable): Promise<GetStripeLinkResponse>{
    return this.axiosService.post(GET_STRIPE_REDIRECT_URL, OPERATION.GetStripeRedirectUrl, variable);
  }

  getBraintreeToken(variable): Promise<GetBraintreeTokenResponse>{
    return this.axiosService.post(GET_BRAINTREE_TOKEN, OPERATION.GetBrainTreeClientToken, variable, false);
  }

  makeBraintreePayment(payload){
    // return this.apiService.postProvider('mobile/braintree/transaction', payload);
    return this.apiService.postProvider(API_END_POINT.brainTreePayment, payload);
  }

  getXenditInvoiceUrl(variable): Promise<GetXenditInvoiceResponse>{
    return this.axiosService.post(GET_XENDIT_INVOICE_URL, OPERATION.GetXenditInvoiceURL, variable);
  }

  getMonerisTicket(variable): Promise<GetMonerisTicketResponse>{
    return this.axiosService.post(GET_MONERIS_TICKET, OPERATION.GetMonerisTicket, variable);
  }

  monerisPaymentReceipt(payload){
    // return this.apiService.postProvider('moneris/response', payload);
    return this.apiService.postProvider(API_END_POINT.monerisPaymentReceipt, payload);
  }

  getAuthorizeNetToken(variable): Promise<GetAuthorizeNetClientTokenResponse>{
    return this.axiosService.post(GET_AUTHORIZE_NET_TOKEN, OPERATION.GetAuthorizeNetClientToken, variable);
  }
  
  getHeartlandHash(variable): Promise<GetHeartlandHashResponse>{
    return this.axiosService.post(GET_HEARTLAND_HASH, OPERATION.GetHeartlandHash, variable);
  }

  getBalanceByCustomHeader(header: CustomHttpHeader, accountId: number): Promise<UserBalanceResponse> {
    return this.axiosService.postByCustomHeader(GET_BALANCE, OPERATION.UserBalance, undefined, true, header, accountId);
  }

  getEGHLHash(variable): Promise<GetEGHLHashResponse>{
    return this.axiosService.post(GET_EGHL_HASH, OPERATION.GetEGHLHash, variable);
  }
}
